import { UrlPlatform } from '@/utils/platform';

export interface PublicState {
  // 是否黑暗模式
  isDark: boolean;
  // 一戶通服務還是商社通服務
  platform: UrlPlatform;
  // 主題色是藍色還是綠色
  brandColor: 'green' | 'blue';
}

export const publicInitState = {
  isDark: false,
  platform: UrlPlatform.personal,
  brandColor: 'green',
};

export default {
  namespace: 'public',
  state: publicInitState,

  reducers: {
    update: (state: PublicState, { payload }: { payload: Partial<PublicState> }) => ({
      ...state,
      ...payload,
    }),
    init: () => publicInitState,
  },
};
